import { doc, setDoc, collection, addDoc, getDoc, updateDoc } from "firebase/firestore";
import moment from "moment";

import firebase from "./firebase";

const { db } = firebase;

export const createUser = async (uid, data) => {
    const ref = doc(db, "users", uid);
    const result = await setDoc(ref, { uid, ...data }, { merge: true });

    return result;
};

export const readDocument = async (collection, id) => {
    const ref = doc(db, collection, id);
    const docSnap = await getDoc(ref);

    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        return null;
    }
};

export const updateDocument = async (collection, id, data) => {
    const ref = doc(db, collection, id);
    await updateDoc(ref, data);
};

export const createEvent = async ({
    nameId,
    communityName,
    uid,
    name,
    email,
    phone,
    type,
    createdAt = moment().format("YYYY-MM-DD HH:mm:ss"),
}) => {
    if (typeof email !== "string") {
        email = "";
    }
    if (typeof phone !== "string") {
        phone = "";
    }
    if (typeof name !== "string") {
        name = "";
    }

    // we need to have at least one of the fields name, email, phone, uid.
    if (!name && !email && !phone && !uid) {
        return;
    }

    if (!nameId || !communityName || !type) {
        return;
    }

    const ref = collection(db, "events");
    const docRef = await addDoc(ref, {
        nameId,
        communityName,
        uid,
        name,
        email,
        phone,
        type,
        createdAt,
    });
};
